export const LIVE_ACTION_BUTTON_COPY = {
  nextQuestion: 'Next',
  submit: 'Submit',
  returnToOverview: 'Return to overview ',
  comment: 'Comment',
};
